export default __webpack_public_path__ + "static/media/cross_red_bg.0ea856ef.svg";